/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditorProjectUpdate
 */
export interface EditorProjectUpdate {
    /**
     * 
     * @type {number}
     * @memberof EditorProjectUpdate
     */
    file?: number;
    /**
     * 
     * @type {number}
     * @memberof EditorProjectUpdate
     */
    parent?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorProjectUpdate
     */
    parentPath?: string;
    /**
     * 
     * @type {number}
     * @memberof EditorProjectUpdate
     */
    existingFile?: number;
    /**
     * 
     * @type {string}
     * @memberof EditorProjectUpdate
     */
    format?: string;
    /**
     * 
     * @type {object}
     * @memberof EditorProjectUpdate
     */
    project: object;
}

export function EditorProjectUpdateFromJSON(json: any): EditorProjectUpdate {
    return EditorProjectUpdateFromJSONTyped(json, false);
}

export function EditorProjectUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditorProjectUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': !exists(json, 'file') ? undefined : json['file'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'parentPath': !exists(json, 'parent_path') ? undefined : json['parent_path'],
        'existingFile': !exists(json, 'existing_file') ? undefined : json['existing_file'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'project': json['project'],
    };
}

export function EditorProjectUpdateToJSON(value?: EditorProjectUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': value.file,
        'parent': value.parent,
        'parent_path': value.parentPath,
        'existing_file': value.existingFile,
        'format': value.format,
        'project': value.project,
    };
}


